export default {
  beforeMount(el, bindings, _vnode) {
    let input;
    if (bindings.value && bindings.value.selectorElemento) {
      input = el.querySelector(bindings.value.selectorElemento);
    } else {
      input = el;
    }
    input.addEventListener('change', () => {
      input.closest('form').requestSubmit();
    });
  },
};
